import { useTranslation } from 'react-i18next';

import type { GDPRTranslations } from '@shared/dream-components/src/types';

const useGDPRTranslations = (): GDPRTranslations => {
  const { t } = useTranslation();
  return {
    consentText: t('shared.cta.gdpr_signup_consent') || 'I consent to receive newsletters via email.',
    termsOfUseText: t('footer.terms_of_use') || 'Terms of Use',
    privacyPolicyText: t('footer.privacy_policy') || 'Privacy Policy',
    andText: t('shared.cta.and') || 'and',
    consentTextVariantTwo:
      `${t('shared.cta.gdpr_signup_consent')} ${t('shared.cta.sign_up')}` ||
      'I consent to receive newsletters via Email. Signup',
    termsOfServiceText: t('meta.titles.tos') || 'Terms of Service',
    chooseNewslettersText: t('shared.cta.choose_newsletters') || 'Choose your newsletters',
    selectAllText: t('shared.cta.select_all') || 'Select all',
  };
};

export default useGDPRTranslations;
